import React from "react";
import { Link } from "react-router-dom";

const prismLogo = "https://customer-assets.emergentagent.com/job_multi-brand-portal/artifacts/dkrj21tk_Studio%20Prism%20Entertainment%20Logo.png";
const guildLogo = "https://customer-assets.emergentagent.com/job_multi-brand-portal/artifacts/cf5fduyf_Academic%20Guild%20Crest.png";
const apothecarySign = "https://customer-assets.emergentagent.com/job_portal-prism-guild/artifacts/qpfvf9oi_For%20emergent.png";
const howlingLogo = "/howling-hills-crest.png";

export default function Home() {
  return (
    <main className="section py-16">
      <header className="text-center mb-12">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Multi-Brand Portal</h1>
        <p className="text-white/70 mt-2">Select a brand to enter its dedicated experience.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Link to="/Prism" className="brand-card p-6 flex items-center gap-4">
          <img src={prismLogo} alt="Studio Prism Entertainment Logo" className="w-20 h-20 object-contain" />
          <div>
            <h2 className="text-xl font-semibold">Studio Prism Entertainment</h2>
            <p className="text-white/60 text-sm">K‑pop studio portal</p>
          </div>
        </Link>

        <Link to="/Academic-Guild" className="brand-card p-6 flex items-center gap-4">
          <img src={guildLogo} alt="Academic Guild Crest" className="w-20 h-20 object-contain" />
          <div>
            <h2 className="text-xl font-semibold">Academic Guild</h2>
            <p className="text-white/60 text-sm">Howling Hills Academic Guild</p>
          </div>
        </Link>

        <Link to="/apothecary" className="brand-card p-6 flex items-center gap-4">
          <img src={apothecarySign} alt="The Blind Apothecary sign" className="w-20 h-20 object-cover rounded-md" />
          <div>
            <h2 className="text-xl font-semibold">The Blind Apothecary</h2>
            <p className="text-white/60 text-sm">Ashes of Creation crafting orders</p>
          </div>
        </Link>

        <Link to="/howling-hills/applications" className="brand-card p-6 flex items-center gap-4">
          <img src={howlingLogo} alt="Howling Hills Applications" className="w-20 h-20 object-contain rounded-md" />
          <div>
            <h2 className="text-xl font-semibold">Howling Hills – Applications &amp; Forms System</h2>
            <p className="text-white/60 text-sm">Centralized reports, feedback, and applications</p>
          </div>
        </Link>
      </div>
    </main>
  );
}